import { Chip as ChipMui, styled } from '@/shared/ui';

export const Chip = styled(ChipMui)(({ theme, color }) => ({
  borderRadius: '8px',
  padding: '0 12px',
  color: theme.palette.common.black,
  fontSize: '12px',

  ...(color === 'error' && {
    backgroundColor: theme.palette.error.light,
  }),

  ...(color === 'info' && {
    backgroundColor: theme.palette.info.light,
  }),
}));
